import '../../../theme/partials/_amount.scss';

import { ReactNode } from 'react';

import useMediaQuery, { Breakpoint } from '@/hooks/useMediaQuery';

import DashboardTableDesktop from './_layouts/DashboardTableDesktop/DashboardTableDesktop';
import DashboardTableMobile from './_layouts/DashboardTableMobile/DashboardTableMobile';

export interface DashboardTableProps {
  data: any;
  loadingData: boolean;
  isRefreshing: boolean;
  onScrollEnd: (event?: CustomEvent) => void;
  moreItems: boolean;
  onChangeShowAGCode?: (showAgCode: boolean) => void;
  // Sustituye el texto del estado vacío (p. ej. un error de validación de fechas)
  emptyMessage?: ReactNode;
  emptyMessageId?: string;
}

export default function DashboardTable({
  data,
  loadingData,
  isRefreshing,
  onScrollEnd,
  moreItems,
  onChangeShowAGCode,
  emptyMessage,
  emptyMessageId,
}: DashboardTableProps) {
  const isDesktopLarge = useMediaQuery(Breakpoint.DesktopLarge);
  const isTablet = useMediaQuery(Breakpoint.Tablet);

  return (
    <>
      { (isDesktopLarge || isTablet) && (
      <DashboardTableDesktop
        data={data}
        onChangeShowAGCode={onChangeShowAGCode!}
        loadingData={loadingData}
        isRefreshing={isRefreshing}
        onScrollEnd={onScrollEnd}
        moreItems={moreItems}
        emptyMessage={emptyMessage}
        emptyMessageId={emptyMessageId}
      />
      ) }

      { (!isDesktopLarge && !isTablet) && (
      <DashboardTableMobile
        data={data}
        onChangeShowAGCode={onChangeShowAGCode!}
        loadingData={loadingData}
        isRefreshing={isRefreshing}
        onScrollEnd={(event?: CustomEvent) => {
          onScrollEnd(event); // Pasa el evento al manejador de scroll
        }}
        moreItems={moreItems}
        emptyMessage={emptyMessage}
        emptyMessageId={emptyMessageId}
      />
      )}
    </>
  );
}
